import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';

import type { ComputeWeightDifferenceRequest, WeightDifferenceCheckDto } from './types';

/**
 * Weight-difference check API.
 *
 * Endpoints (backend/src/modules/field_capture/routes.rs):
 *   GET  /api/monthly-batches/:batchId/weight-difference-checks  -> list (newest-first)
 *   POST /api/monthly-batches/:batchId/weight-difference-checks  -> compute/record
 *   POST /api/weight-difference-checks/:id/confirm               -> DK-side confirm
 *   POST /api/weight-difference-checks/:id/ef-confirm            -> EF-side confirm
 */

/** List the batch's weight-difference checks (backend orders newest-first). */
export const fetchWeightDifferenceChecks = async (
  batchId: string,
): Promise<WeightDifferenceCheckDto[]> => {
  const res = await apiClient.get<ApiSuccess<WeightDifferenceCheckDto[]>>(
    `/monthly-batches/${batchId}/weight-difference-checks`,
  );
  return res.data.data ?? [];
};

/** Record a dispatch-vs-inbound comparison. Gated by receiving.individual_weight.input. */
export const computeWeightDifferenceCheck = async (
  batchId: string,
  body: ComputeWeightDifferenceRequest,
): Promise<WeightDifferenceCheckDto> => {
  const res = await apiClient.post<ApiSuccess<WeightDifferenceCheckDto>>(
    `/monthly-batches/${batchId}/weight-difference-checks`,
    body,
  );
  return res.data.data;
};

/** DK-side confirm. Gated by receiving.weight_discrepancy.confirm_major. */
export const confirmWeightDifferenceCheck = async (
  id: string,
): Promise<WeightDifferenceCheckDto> => {
  const res = await apiClient.post<ApiSuccess<WeightDifferenceCheckDto>>(
    `/weight-difference-checks/${id}/confirm`,
  );
  return res.data.data;
};

/** EF-side confirm. Gated by estimation.final_decide. */
export const efConfirmWeightDifferenceCheck = async (
  id: string,
): Promise<WeightDifferenceCheckDto> => {
  const res = await apiClient.post<ApiSuccess<WeightDifferenceCheckDto>>(
    `/weight-difference-checks/${id}/ef-confirm`,
  );
  return res.data.data;
};
